import { getCookieValue } from '@/lib/utils';
import { useEffect, useState } from 'react';

export function useDarkMode() {
  const [isDark, setIsDark] = useState<boolean>(() => {
    // Default to labos value
    const stored = localStorage.getItem('darkMode');
    const globalValue = getCookieValue('darkMode') === 'true';

    const isDarkMode = stored === null ? globalValue : stored === 'true';

    // Apply dark class immediately during initialization to avoid flash
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }

    return isDarkMode;
  });

  useEffect(() => {
    // Apply or remove dark class to document root
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    // Save to localStorage
    localStorage.setItem('darkMode', String(isDark));
  }, [isDark]);

  const toggleDarkMode = () => setIsDark((prev) => !prev);

  return { isDark, toggleDarkMode };
}
